export default __webpack_public_path__ + "static/media-01-80fb0a8f68173bdab0c6a49720f74a9a.png";